import { render } from "./FriendlyCaptcha.vue?vue&type=template&id=49463e50"
import script from "./FriendlyCaptcha.vue?vue&type=script&lang=js"
export * from "./FriendlyCaptcha.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/auth/FriendlyCaptcha.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49463e50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49463e50', __exports__)) {
    api.reload('49463e50', __exports__)
  }
  
  module.hot.accept("./FriendlyCaptcha.vue?vue&type=template&id=49463e50", () => {
    api.rerender('49463e50', render)
  })

}


export default __exports__